import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1e88e5',
        secondary: '#2ecc71',
        background: '#f9fafb'
      }
    }
  }
})
